"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SharkFin = void 0;
var figureBase_1 = require("../../../core/base/figureBase");
var line3_1 = require("../../../core/base/line3");
var three_1 = require("three");
var SharkFin = /** @class */ (function (_super) {
    __extends(SharkFin, _super);
    function SharkFin() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SharkFin.prototype.calculateConnectionIndexes = function () {
        return [0];
    };
    SharkFin.prototype.calculateLines = function () {
        var width = this.config.options.width;
        var height = this.config.options.height;
        var aPoint = new three_1.Vector3(width / 2, 0);
        var bPoint = new three_1.Vector3(-width / 2, 0);
        var cPoint = new three_1.Vector3(-width * 0.35, height * 0.7);
        var dPoint = new three_1.Vector3(-width / 2 * 0.55, height * 0.95);
        var ePoint = new three_1.Vector3(-width / 8, height);
        var fPoint = new three_1.Vector3(0, height);
        var hPoint = new three_1.Vector3(width / 8, height * 0.89);
        var iPoint = new three_1.Vector3(width / 2 * 0.7, height * 0.7);
        return [
            new line3_1.Line3(line3_1.LineType.Straight, [aPoint, bPoint]),
            new line3_1.Line3(line3_1.LineType.Straight, [bPoint, cPoint]),
            new line3_1.Line3(line3_1.LineType.BazierCurve, [cPoint, dPoint, ePoint]),
            new line3_1.Line3(line3_1.LineType.BazierCurve, [ePoint, fPoint, hPoint]),
            new line3_1.Line3(line3_1.LineType.BazierCurve, [hPoint, iPoint, aPoint]),
        ];
    };
    SharkFin.prototype.getConfigProperties = function () {
        return {
            width: 1,
            height: 1
        };
    };
    return SharkFin;
}(figureBase_1.FigureBase));
exports.SharkFin = SharkFin;
